function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M485.967,233.617c-74-91-153.9-137.2-237.7-137.2c-33.2,0-66.8,7.4-100,21.9c-26.1,11.5-52,27.4-76.9,47.3 c-42.1,33.7-66.9,67.3-67.9,68.7c-4.8,6.6-4.6,15.6,0.5,22c73.9,91.1,153.9,137.2,237.7,137.2c33.2,0,66.8-7.4,100-21.9 c26.1-11.5,52-27.4,76.9-47.3c42.1-33.7,66.9-67.3,67.9-68.7C491.267,249.017,491.067,240.017,485.967,233.617z M395.267,296.817 c-34.8,27.7-89.6,60.7-153.6,60.7c-69.1,0-136.5-37.9-200.5-112.7c10.1-11.9,28.6-31.8,53.4-51.6c34.8-27.7,89.6-60.7,153.6-60.7 c69.1,0,136.5,37.9,200.5,112.7C438.567,257.117,420.067,277.117,395.267,296.817z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M311.267,227.017c-9.9,0-18,8.1-18,18c0,26.7-21.7,48.4-48.4,48.4c-26.7,0-48.4-21.7-48.4-48.4 c0-26.7,21.7-48.4,48.4-48.4c9.9,0,18-8.1,18-18c0-9.9-8.1-18-18-18c-46.6,0-84.4,37.9-84.4,84.4s37.8,84.4,84.4,84.4 c46.6,0,84.4-37.9,84.4-84.4C329.267,235.117,321.167,227.017,311.267,227.017z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489.934 489.934",
    style: {
      enableBackground: "new 0 0 489.934 489.934"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e47c1c60.svg";
export { ForwardRef as ReactComponent };